import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import LeftArea from './leftArea/LeftArea';
import MiddleArea from './middleArea/MiddleArea';
import RightArea from './../../../../components/FlowConfigurationForms';
import TestAppLog from './middleArea/TestAppLog/testAppLog';
import { useParams } from "react-router-dom";
import AutomService from '../../../../services/AutomService/AutomService';
import triggerService from '../../../../services/triggerService/triggerService';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import {
    activeAutom,
    activeTab,
    alertState,
    defaultItems,
    defaultTriggerItem,
    debugList,
    licensePermission,
    triggerConf,
    fieldPreviewData,
    triggerSelection, testAppLog
} from '../../../../recoil-store/recoil-state';
import VariableService from '../../../../services/VariableService/VariableService';
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import './NewFlow.css';
import { changeOrder, handleDebugArray, valueController } from '../../../../helpers/helper';
import { useTranslation } from 'react-i18next';
import QueueService from '../../../../services/QueueService/QueueService';
import WaitingQueueModal from '../autom/component/WaitingQueueModal';
import RunningModal from '../autom/component/RunningModal';
import ExportConfirm from '../../../../components/Export/ExportConfirm';
import ImportModal from '../../../../components/Import/ImportModal';
import SlowMotionModal from '../../../../components/SlowMotion/SlowMotionModal';
import Publish from '../publish/Publish';
import EditAutomName from '../autom/editAction/editAutomName/EditAutomName';
import Schedule from '../Schedule/Schedule';
import TriggerModal from '../autom/header/TriggerModal';
import MateDrive from '../../../../components/MateDrive/MateDrive';
import Debugger from '../autom/debugger';
import Roi from "../roi/Roi";
import { useRecoilActions } from '../../../../recoil-store/recoil-actions';
import { handleInit } from '../../../../helpers/flowHistory';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { useNavigate } from 'react-router-dom'
import DeleteConfirm from "../../../../components/DataTable/DeleteConfirm";
import automService from "../../../../services/AutomService/AutomService";
import BotService from '../../../../services/BotService/BotService';

const NewFlow = (props) => {
    let params = useParams();
    const history = useNavigate()

    const paramsId = params.id;
    const license = useRecoilValue(licensePermission);
    const [testAppLogs, setTestAppLogs] = useRecoilState(testAppLog);
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const recoilActions = useRecoilActions();
    const { t } = useTranslation();
    const [openVariable, setOpenVariable] = useState({ type: "", id: "" });
    const [showRightArea, setShowRightArea] = useState(false);
    const [openResetTrigger, setOpenResetTrigger] = useState(false);
    const [showTriggerRightArea, setShowTriggerRightArea] = useState(false);
    const recorder = useRef([]);
    const drecorder = useRef([]);
    const [groupLabel, setGroupLabel] = useState("");
    const [loader, setLoader] = useState(true);
    const [tabFilter, setTabFilter] = useRecoilState(activeTab);
    const [detailTabs, setDetailTabs] = useState([]);
    const [variables, setVariables] = useState([]);
    const [actions, setActions] = useState({});
    const [automVersion, setAutomVersion] = useState('');
    const [operationId, setOperationId] = useState("");
    const [openWaitingQueueModal, setOpenWaitingQueueModal] = useState(false);
    const [numberQueue, setNumberQueue] = useState(0);
    const [openRunningModal, setOpenRunningModal] = useState(false);
    const [openDebugRunning, setOpenDebugRunning] = useState(false);
    const [debuggingStart, setDebuggingStart] = useState(false);
    const [debuggingDelay, setDebuggingDelay] = useState(1000);
    const [flowStatus, setFlowStatus] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [openPublish, setOpenPublish] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [reCheck, setReCheck] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [triggerModal, setTriggerModal] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [triggerType, setTriggerType] = useState('');
    const [openSchedule, setOpenSchedule] = useState(false);
    const [openDrive, setOpenDrive] = useState(false);
    const [openExport, setOpenExport] = useState(false);
    const [openImport, setOpenImport] = useState(false);
    const [openSlowMotion, setOpenSlowMotion] = useState(false);
    const [debuggingExpand, setDebuggingExpand] = useState(false);
    const [publishFlowData, setPublishFlowData] = useState([]);
    const [openRoi, setOpenRoi] = useState(false);
    const [diagramData, setIsDiagramData] = useState([]);
    const [exportData, setExportData] = useState({});
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [debugErrorMessage, setDebugErrorMessage] = useState();
    const setTriggerConf = useSetRecoilState(triggerConf);
    const setTriggerSelection = useSetRecoilState(triggerSelection);
    const setFieldPreviewData = useSetRecoilState(fieldPreviewData);
    const [triggerSelectionData, setTriggerSelectionData] = useRecoilState(triggerSelection);
    const [loading, setLoading] = useState(true);
    const [openTestAppLog, setOpenTestAppLog] = useState(false);
    const [testAppStarted, setTestAppStarted] = useState(false);

    const [isDiagramBuilder, setIsDiagramBuilder] = useState(
        !(
            localStorage.getItem("tabs") !== null &&
            localStorage.getItem("tabs") !== undefined &&
            localStorage.getItem("tabs") === "diagram"
        )
    );

    const setAlert = useSetRecoilState(alertState);
    const setClearDebugs = useSetRecoilState(debugList);

    useEffect(() => {
        if (!openTestAppLog) {
            setTestAppLogs({});
        }
    }, [openTestAppLog]);


    const resetFlow = async () => {
        setActions({})
        if (automDetail.is_installed) {
            const result = await BotService.getInitialFlow(automDetail.versionId);
            if (result.code === 200) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.RESET-FOR-DOWNLOADED-BOT'),
                    severity: 'info'
                }))
                setAutomDetail({
                    ...automDetail,
                    items: result.data,
                    activeItem: []
                })
                setTabFilter(0)
                return
            }
            setAlert(alert => ({
                ...alert,
                show: true,
                message: result ? result.message : t('GENERAL.NETWORK-ERROR'),
                severity: 'error'
            }))
        }
        let dItem = JSON.parse(JSON.stringify(defaultItems));
        if (automDetail.type === 'Autom') {
            dItem.unshift(JSON.parse(JSON.stringify(defaultTriggerItem)));
        }
        setAutomDetail({
            ...automDetail,
            items: dItem,
            activeItem: []
        })
        setTabFilter(0)
    }

    const handleExport = async (e) => {
        if (automDetail.items.length > 2) {
            let payloadData = await preparePayloadData("save");
            const response = await AutomService.exportFlow(
                payloadData
            );
            if (response.status) {
                setOpenExport(true);
                setExportData({
                    flow: response.data.flow,
                    variables: response.data.variables,
                    fileName: automDetail.name
                });
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(response.message),
                    severity: 'error'
                }))
            }
        }
    }

    const handleImport = (e) => {
        setOpenImport(true);
    }

    const handleSlowMotion = (e) => {
        setOpenSlowMotion(true);
    }

    const handleDragEnd = (e, item, isMove, copy) => {
        const conditionHover = document.getElementsByClassName("new-flow-drag-hover-condition");
        Array.prototype.forEach.call(conditionHover, function (el) {
            // Do stuff here
            el.classList.remove('active');
        });

        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            // Do stuff here
            el.classList.remove('active');
        });
    }

    const showHorizontalDroppableAreas = (it, me) => {
        const conditionHover = document.getElementsByClassName("new-flow-drag-hover-condition");
        Array.prototype.forEach.call(conditionHover, function (el) {
            // Do stuff here
            Array.prototype.forEach.call(me, function (search) {
                if (it === 'else') {
                    checkAndShowNextConditionArea(el, search);
                } else {
                    showNextConditionArea(el, search);
                }

            })
        });

        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            // Do stuff here
            Array.prototype.forEach.call(me, function (search) {
                if (it === 'else') {
                    checkAndShowNextConditionArea(el, search);
                } else {
                    showNextConditionArea(el, search);
                }
            })
        });
    }

    const showNextConditionArea = (el, search) => {
        if (el.classList.contains(search)) {
            el.classList.add('active');
        }
    }

    const checkAndShowNextConditionArea = (el, search) => {
        const cId = el.getAttribute('condgroupid');
        if (search === "elseif") {
            const isElseExist = document.getElementsByClassName("else-" + cId)
            if (isElseExist.length === 0) {
                if (el.classList.contains(search)) {
                    el.classList.add('active');
                }
            }
        } else {
            const isElseExist = document.getElementsByClassName("else-" + cId)
            const isElseIfExist = document.getElementsByClassName("elseif-" + cId)
            if (isElseExist.length === 0 && isElseIfExist.length === 0) {
                if (el.classList.contains(search)) {
                    el.classList.add('active');
                }
            }
        }
    }

    const handleDragStart = (e, item, isMove, copy) => {
        // >>>>> DON'T DELETE BELOW COMMENTED LINES
        // let img = document.createElement('img');
        // let canvas = document.createElement('canvas');
        // let ctx = canvas.getContext('2d');
        // img.src = libraryIconsDrag[item.library_name.replace(/-/g, "_").toLowerCase()];
        // img.style.height = '10px';
        // img.style.width = '10px';
        // canvas.height = 30;
        // canvas.width = 30;
        // canvas.backgroundColor = "#F4BB66";
        // ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // e.dataTransfer.setDragImage(img, 0, 0);

        item = JSON.parse(JSON.stringify(item))

        if (!isMove || !item.item_id) {
            item.item_id = uuidv4();
        }
        if (isMove && actions[automDetail.activeItem[0]?.id] && actions[automDetail.activeItem[0]?.id].inputs) {
            item.inputs = actions[automDetail.activeItem[0]?.id].inputs
        }
        if (item.action_name === "ELSE") {
            showHorizontalDroppableAreas("else", ["if", "elseif"])
        }

        if (item.action_name === "ELSEIF") {
            showHorizontalDroppableAreas("elseif", ["if", "elseif"])
        }

        if (item.action_name === "LIST-ITEM") {
            showHorizontalDroppableAreas("listitem", ["list-item"])
        }

        if (item.action_name === "BUTTON-ITEM") {
            showHorizontalDroppableAreas("buttonitem", ["button-item"])
        }

        if (e?.stopPropagation) e.stopPropagation();
        if (!isMove || item.action_name !== "IF")
            if (e?.stopPropagation)
                e.stopPropagation();
        if (copy) {
            localStorage.setItem("copiedItem", JSON.stringify({ item, isMove }));
        } else {
            localStorage.setItem("dragItem", JSON.stringify({ item, isMove }));
        }
    };

    const handleShowRightArea = () => {
        if (automDetail.activeItem[0]) {
            const hasKeys = !!Object.keys(automDetail.activeItem[0])?.length;
            if (hasKeys && automDetail.activeItem[0].actionName === 'TRIGGER') setShowTriggerRightArea(true)
            if (hasKeys && automDetail.activeItem[0].actionName !== 'START') setShowRightArea(true)
        }
    }

    // const handleShowTriggerRightArea = () => {
    //     setShowTriggerRightArea(true);
    // }

    const findAndUpdateItem = (id, items) => {
        items.forEach(item => {
            if (item.id === id) {
                item.fields = actions[id].fields
                item.inputs = actions[id].inputs
            } else if (item.children) {
                findAndUpdateItem(id, item.children)
            }
        })
    }

    const dragItemSetField = (item, isMove, copy) => {
        let dragItem;
        if (copy) dragItem = JSON.parse(localStorage.getItem("copiedItem"));
        else dragItem = JSON.parse(localStorage.getItem("dragItem"));
        if (actions[dragItem?.item?.id]?.id) {
            item = {
                ...item,
                fields: actions[dragItem.item.id].fields
            }
        }


        return item;
    }

    const preparePayloadData = async (type = "null", opId = "") => {
        let items = JSON.parse(JSON.stringify(automDetail.items))
        items = resetItemsDebug(items)
        Object.keys(actions).forEach(actionId => {
            findAndUpdateItem(actionId, items)
        })
        // if(type === 'save'){
        //     items = items.filter(x => x.name !== 'TRIGGER');
        // }
        changeOrder(items, 0);
        if (type === "save") {
            return {
                autom_id: paramsId,
                operationId: opId?.length > 0 ? opId : operationId,
                version_id: automVersion?.length ? automVersion : "",
                updatingFields: [{ field_name: "flow", field_value: items }, {
                    field_name: "diagram",
                    field_value: diagramData
                }] // , { field_name: "trigger", field_value: triggerConfig }
            };
        } else if (type === "run") {
            items.splice(0, 1);
            return {
                flowActions: {
                    id: paramsId,
                    autom_version_id: automDetail.versionId,
                    name: automDetail.name,
                    description: automDetail.description,
                    integration_type: automDetail.integration_type,
                    mate_id: automDetail.mate_id,
                    actions: items,
                    operationId: opId?.length > 0 ? opId : operationId,
                    isDebugging: debuggingStart, // debugger,
                    debuggingDelay: debuggingDelay,
                    queue_enabled: automDetail.queue_enabled,
                    qpool_id: automDetail.qpool_id
                },
            };
        } else if (type === "debug") {
            items.splice(0, 1);
            if (findDebugAction(items)) {
                await handleDebugArray(items)
            }
            return {
                flowActions: {
                    id: paramsId,
                    autom_version_id: automDetail.versionId,
                    name: automDetail.name,
                    description: automDetail.description,
                    integration_type: automDetail.integration_type,
                    mate_id: automDetail.mate_id,
                    actions: items,
                    operationId: opId?.length > 0 ? opId : operationId,
                    isDebugging: debuggingStart, // debugger
                    debuggingDelay
                },
            };
        } else if (type === "publish") {
            return items;
        }

        return items;
    }

    const saveFlow = async () => {
        let payloadData = await preparePayloadData("save");
        const { status } = await AutomService.updateAutom(
            payloadData,
            paramsId
        );
        if (status) {
            setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.AUTOMS.AUTOM-SAVED"), severity: 'success' }))
            getVariables(automDetail.versionId)
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.AUTOMS-ADDED-FAILED"),
                severity: 'error'
            }))
        }
    }

    function findDebugAction(items) {
        for (let i = 0; i < items.length; i++) {
            if ('children' in items[i]) {
                if (findDebugAction(items[i].children)) {
                    return true;
                }
            }
            if (items[i].isDebugging) {
                return true
            }
        }
        return false;
    }

    const runFlow = async () => {
        setClearDebugs([]);

        // data convert and sort
        let payloadData = await preparePayloadData(debuggingStart ? "debug" : "run");

        // check empty field
        const isNullControl = await valueController(payloadData.flowActions.actions, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }
        const { status, data, message } = await AutomService.generateOperation(
            paramsId,
            automDetail.mate_id,
            false, // debugging Start
        );
        if (status && data) {
            setOperationId(data.operationId);
            // resp : number of autom waiting
            const responseQueue = await QueueService.getQueueStatus();
            let queue = false; // queue = false because we want flow to start directly
            if (responseQueue?.data?.count > 0 && queue) {
                await saveFlow();
                //then open waiting queue modal
                setNumberQueue(responseQueue?.data?.count);
                setOpenWaitingQueueModal(true);
            } else {
                //running flow now
                recoilActions.connection();
                if (debuggingStart) {
                    setOpenDebugRunning(true);
                    resetDebugStatus();
                } else
                    setOpenRunningModal(true);

                // set operationId
                payloadData.flowActions.operationId = data.operationId;
                const response = debuggingStart
                    ? await AutomService.debuggingAutom(payloadData)
                    : await AutomService.runAutom(payloadData);
                setOpenDebugRunning(false);

                if (response?.status) {
                    // setFlowstatus :1 response success
                    setFlowStatus(1);
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.AUTOMS.AUTOM-RUN"),
                        severity: 'success'
                    }))
                } else {
                    // setFlowstatus :2 response fail
                    setFlowStatus(2);
                    if (response) {
                        if (response.message.includes("System Error:")) {
                            setErrorMessage(response.message);
                            //setErrorMessage(response.message.replace("System Error:", ""));
                        } else {
                            setErrorMessage(
                                t("FLOW-MESSAGES.LIBRARY." + response?.message)
                            );
                        }
                    } else {
                        setErrorMessage(
                            t("GENERAL.NETWORK-ERROR")
                        );
                    }
                }
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + message),
                severity: 'error'
            }))
        }
    }

    function handleDebugIconShow(id, items) {
        return items.map(item => {
            return { ...item };
        }).map(item => {
            if (item.hasOwnProperty('children')) {
                item.children = handleDebugIconShow(id, item.children);
            }
            if (item.id === id) {
                item.isDebugging = !item.isDebugging;
            } else {
                item.isDebugging = false;
            }
            return item;
        });
    }

    const debugFlow = () => {
        // clear debug datas when opening/closing debug console
        setClearDebugs([]);

        // clear isDebugging all actions
        const modifiedItems = handleDebugIconShow('ALL', automDetail.items);
        setAutomDetail({
            ...automDetail, items: modifiedItems
        });

        setDebuggingStart(old => !old)
        if (debuggingStart) resetDebugStatus();
    }

    const editFlow = async () => {
        setOpenEdit(true);
    }

    const publishFlow = async () => {
        let dataControl = await preparePayloadData(" ");
        const isNullControl = await valueController(dataControl, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }
        let payloadData = await preparePayloadData("publish");
        if (payloadData.length < (automDetail.type === 'Action' ? 3 : 4)) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.PUBLISH.EMPTY-FLOW-ITEMS"),
                severity: 'info'
            }))
        } else if (license.data.action_limit < payloadData.length - 2) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.PUBLISH.ACTION-LIMIT-EXCEEDED") + license.data.action_limit,
                severity: 'info'
            }))
        } else if (automDetail.type === 'Action' && variables.findIndex(x => x.type === 'app connector') === -1) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.PUBLISH.APP-CONNECTOR-NOT-FOUND"),
                severity: 'info'
            }))
            setOpenVariable(true);
        } else {
            setOpenPublish(true);
            setPublishFlowData(payloadData);
        }
    }

    function getVariables(autom_version_id) {
        VariableService.getVariable(autom_version_id).then((response) => {
            setVariables(response.data);
        });
    }

    useEffect(() => {
        localStorage.removeItem("dragItem")

        async function getAutomDetail() {
            setLoader(true);
            const response = await AutomService.getAutomsById(paramsId);
            if (response?.code && response.code === '404') {
                history('/my-environment/autom-list');
                return;
            }

            let dItem = JSON.parse(JSON.stringify(defaultItems));
            if (response.data.type === 'Autom') {
                dItem.unshift(JSON.parse(JSON.stringify(defaultTriggerItem)));
            }
            handleInit(response.data?.flow?.length > 1 ? response.data?.flow : dItem);
            if (response?.data?.diagram?.length > 0) {
                setIsDiagramData(response.data.diagram)
            }

            if (response?.data?.trigger_type) {
                setTriggerSelection(response?.data?.trigger_type.split(','));
            } else {
                setTriggerSelection([]);
            }

            if (response?.data?.application_credential_id && response?.data.trigger_mode_id && response?.data?.trigger_setup) {
                setTriggerConf(conf => ({
                    ...conf,
                    app: {
                        id: response?.data?.application_id,
                        name: response?.data?.application_name,
                        image_path: response?.data?.image_path,
                        connector_fields: response?.data?.connector_fields
                    },
                    trigger: {
                        id: response?.data?.trigger_mode_id,
                        trigger_action_id: response?.data?.trigger_action_id,
                        name: response?.data?.trigger_action_name,
                        type: response?.data?.trigger_action_type
                    },
                    connector: { id: response?.data?.application_credential_id, name: response?.data?.credential_name },
                    setup: response?.data?.trigger_setup
                }))
            } else if (response?.data.trigger_mode_id) {
                setTriggerConf(conf => ({
                    ...conf,
                    app: {
                        id: response?.data?.application_id,
                        name: response?.data?.application_name,
                        image_path: response?.data?.image_path,
                        connector_fields: response?.data?.connector_fields
                    },
                    trigger: {
                        id: response?.data?.trigger_mode_id,
                        trigger_action_id: response?.data?.trigger_action_id,
                        name: response?.data?.trigger_action_name,
                        type: response?.data?.trigger_action_type
                    },
                    connector: {},
                    setup: {
                        fields: {},
                        conditions: [],
                        inputs: {}
                    }
                }))
            } else {
                setTriggerConf({
                    app: {},
                    trigger: {},
                    connector: {},
                    setup: {
                        fields: {},
                        conditions: [],
                        inputs: {}
                    }
                });
                setFieldPreviewData({
                    triggerData: {
                        data: {
                            field_path: {},
                            ff_name_path: {},
                        },
                        inputs: {},
                        inputConfigurations: []
                    }
                });
            }
            setAutomVersion(response.data.versionId);
            setAutomDetail({
                ...automDetail, ...response.data, activeItem: [],
                items: response.data?.flow?.length > 1 ? response.data?.flow : dItem
            });

            getVariables(response.data.versionId);
            // Control is provided after autom details are get.
            await checkIsRunning(response.data);
            // const flow = document.getElementById('new-flow-drop-area-grid');
            // flow.style.left = `calc(50% - ${flow.offsetWidth / 2}px)`;
            setLoader(false);
        }

        getAutomDetail().then(r => r);

    }, [paramsId]);

    useEffect(() => {
        // Check automid because old autom details are coming from recoil
        if (paramsId === automDetail?.id && automVersion === automDetail.versionId) {
            let item;
            if (automDetail.activeItem.length) {
                item = JSON.parse(JSON.stringify(automDetail.activeItem[0]));
            }
            if (item && item.fields && !actions[item.id]) {
                let id = JSON.parse(JSON.stringify(item.id))
                setActions(prev => ({
                    ...prev,
                    [id]: {
                        ...prev[id], fields: JSON.parse(JSON.stringify(item.fields)),
                        actionName: JSON.parse(JSON.stringify(item.actionName)),
                        libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                        application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                        isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                        autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                        libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                        id,
                        item_id: item.item_id,
                        image: item?.image,
                        actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                        inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null
                    }
                }))
            }
            if (automDetail?.activeItem[0]?.name) {
                setShowRightArea(automDetail?.activeItem[0]?.name !== "START");
            }
        }
    }, [automDetail?.activeItem])

    useEffect(() => {
        // Check automid because old autom details are coming from recoil
        if (paramsId === automDetail?.id) {
            let items = JSON.parse(JSON.stringify(automDetail.items))
            if (tabFilter === 0) {
                findHidden('visible', items, false);
            } else {
                let focusedId = detailTabs[tabFilter - 1]?.item?.id; // items.filter(item => item.type !== 'standard')[tabFilter - 1].id;
                findHidden(focusedId || 'visible', items, true);
            }
            setAutomDetail({ ...automDetail, items })
        }
    }, [tabFilter])

    useEffect(() => {
        // Check automid because old autom details are coming from recoil
        if (paramsId === automDetail?.id) {
            checkIsRunning(automDetail).then(r => r);
        }
    }, [reCheck])

    const findHidden = (id, items, hiddenParent) => {
        for (const item of items) {
            if (item.children || item.action_name === 'IF' || item.action_name === 'ELSEIF' || item.action_name === 'ELSE') {
                if (id !== 'visible' && item.id !== id && hiddenParent) {
                    item.hiddenParent = true;
                    if (item.children) findHidden(id, item.children, true);
                } else {
                    item.hiddenParent = false;
                    if (item.children) findHidden(id, item.children, false);
                }
            } else if (id !== 'visible' && item.id !== id && hiddenParent) {
                item.hidden = true;
            } else {
                item.hidden = false;
            }
        }
    }

    // check autom type and if trigger (email,schedule) update setTrigger state
    const checkIsRunning = async (autom) => {
        let type;
        if (autom?.trigger_action_type === 'schedule') {
            type = "APP-SCHEDULE";
        } else if (autom?.trigger_type && autom?.trigger_type.includes('webhook') && autom?.trigger_type.includes('app')) {
            type = "APP-TRIGGER"
        } else if (autom?.trigger_type && autom?.trigger_type.includes('email')) {
            type = "EMAIL";
        } else if (autom?.integration_type === "SCHEDULE") {
            type = "SCHEDULE"
        }
        if (type) {
            const response = await triggerService.checkIsRunningStatus(paramsId, type);
            setIsRunning(response.data.is_running);
            setTrigger(true);
            setTriggerType(type);
        } else {
            setTrigger(false);
        }
    }

    //A new variable will be created when a new trigger flow added.
    async function automaticallyVariableCreation(triggerType) {
        const response = await VariableService.getVariable(automVersion);

        //if integration type is a trigger and We search the
        //variable data, if the name is "trigger Param" we return true otherwise false
        if (triggerType?.split(",")?.includes("webhook") || triggerType?.split(",")?.includes("api")) {
            let filter = response?.data?.some((item) => item.name === "triggerParam");
            if (!filter) {
                const data = {
                    name: "triggerParam",
                    type: "object",
                    type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
                    description: "",
                    is_input: 0,
                    is_output: 0,
                    is_customizable: 0,
                    autom_version_id: automVersion,
                };
                const { status } = await VariableService.postVariable(data);
                if (status) {
                    setVariables(old => [...old, data])
                }
            }
        }
    }

    async function automaticallyWhatsappVariableCreation(itemId, actionLabel) {
        const data = {
            name: `${actionLabel.toLowerCase()}_${itemId.replaceAll('-', '')}`,
            type: "string",
            type_id: "c9057e86-cf7c-4256-8829-3608f447f86c",
            description: "",
            is_input: 0,
            is_output: 0,
            is_customizable: 0,
            autom_version_id: automVersion,
        };
        const { status } = await VariableService.postVariable(data);
        if (status) {
            setVariables(old => [...old, data])
            getVariables(automDetail.versionId)
        }
    }

    const handleStart = async (isTest) => {
        if (isTest) {
            setOpenTestAppLog(true);
            setTestAppStarted(true);
        }
        let dataControl = await preparePayloadData(" ");
        const isNullControl = await valueController(dataControl, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }

        const response = await triggerService.triggerStart({
            autom_id: paramsId,
            type: triggerType,
            it: isTest
        });
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: response?.status ? 'success' : 'error'
            }))
            if (response?.status) {
                //success
                // await saveFlow();
                setIsRunning(true);
            }
        }
    };

    const handleStop = async () => {
        const response = await triggerService.triggerStop({
            autom_id: paramsId,
            type: triggerType,
        });
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: response?.status ? 'success' : 'error'
            }))
            if (response?.status) {
                setIsRunning(false);
                setOpenDebugRunning(false);
            }
        }
    };

    const handleTestAppCancel = async (isTest) => {
        let dataControl = await preparePayloadData(" ");
        const isNullControl = await valueController(dataControl, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }

        const response = await triggerService.triggerStop({
            autom_id: paramsId,
            type: triggerType
        });
        if (response) {
            if (response?.status) {
                const lMessage = isTest ? t("MESSAGES.AUTOMS.TEST-APP-PROCESS-COMPLETED") : t("MESSAGES.AUTOMS.TEST-APP-PROCESS-CANCELED")
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: lMessage,
                    severity: "success"
                }))
                //success
                if (!isTest) {
                    setOpenTestAppLog(false);
                }
                setTestAppStarted(false);
                setIsRunning(false);
            }
        }
    };

    const handleDiagramBuilder = () => {
        setShowRightArea(false);
        setIsDiagramBuilder(old => !old)
    }

    const handleRoi = () => {
        setOpenRoi(old => !old);
    }

    const exportFunc = async (ok) => {
        if (ok) {
            await downloadFile(exportData);
        } else setExportData([]);
    }

    const importFunc = async (file) => {
        const response = await AutomService.importFlow(file, automDetail.versionId);
        if (response) {
            let message = t('MESSAGES.AUTOMS.' + response.message)
            if (response.code === 409) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: message,
                    severity: 'error'
                }));
                return;
            }
            message = !response.status ? message + ` - Variable name : ${response.data?.name}` : message
            setAlert(alert => ({
                ...alert,
                show: true,
                message: message,
                severity: response.status ? 'success' : 'error'
            }));

            if (response.status) {
                handleInit(response.data?.flow?.length > 1 ? response.data?.flow : defaultItems);
                if (response?.data?.diagram?.length > 0) {
                    setIsDiagramData(response.data.diagram)
                }

                const tempAutomDetail = JSON.parse(JSON.stringify(automDetail));
                tempAutomDetail.flow = response.data.flow;
                setAutomDetail({
                    ...automDetail, ...tempAutomDetail, activeItem: [],
                    items: response.data?.flow?.length > 1 ? response.data?.flow : defaultItems
                });
                setOpenImport(false);
                getVariables(automVersion);
                // setAutomVersion(response.vId);
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
        }
    }

    const slowMotionFunc = async (ms) => {
        if (ms >= 1000) {
            setDebuggingDelay(ms);
            setOpenSlowMotion(false);
        }
    }

    const downloadFile = async (data) => {
        const fileName = exportData.fileName;
        const json = JSON.stringify({ flow: data.flow, variables: data.variables });
        const blob = new Blob([json], { type: 'application/json' });
        const href = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = fileName + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const findAndSetDebugStatus = (items, itemId, status, message) => {
        for (const i in items) {
            if (items[i].item_id === itemId) {
                items[i].debugStatus = status

                if (status === "error") {
                    items[i].debugErrorMessage = message;
                }
                break;
            } else if (items[i].hasOwnProperty('children')) {
                items[i].children = findAndSetDebugStatus(items[i].children, itemId, status, message);
            }
        }
        return items;
    }

    const setDebugStatus = (itemId, status, message) => {
        const items = JSON.parse(JSON.stringify(automDetail.items))
        const modifiedItems = findAndSetDebugStatus(items, itemId, status, message)
        setAutomDetail({
            ...automDetail, items: modifiedItems
        });
    }

    function resetItemsDebug(items) {

        return items.map(item => {
            return { ...item };
        }).map(item => {
            item.debugStatus = '';
            if (item.hasOwnProperty('children')) {
                item.children = resetItemsDebug(item.children);
            }
            return item;
        });
    }

    const resetDebugStatus = () => {
        // clear isDebugging all actions
        const modifiedItems = resetItemsDebug(automDetail.items)
        setAutomDetail({
            ...automDetail, items: modifiedItems
        });
    }

    const handleErrorOpenClick = (debugErrorMessage) => {
        setOpenErrorDialog(true);
        setDebugErrorMessage(debugErrorMessage)
    };

    const handleErrorCloseClick = () => {
        setOpenErrorDialog(false);
    };

    const openResetTriggerConfiguration = () => {
        setOpenResetTrigger(true);
    }

    const resetTriggerConfiguration = async () => {
        setTriggerConf({
            app: {},
            trigger: {},
            connector: {},
            setup: {
                fields: {},
                conditions: [],
                inputs: {}
            }
        });
        setFieldPreviewData({
            triggerData: {
                data: {
                    field_path: {},
                    ff_name_path: {}
                },
                inputs: {},
                inputConfigurations: []
            }
        });
        const response = await automService.updateTrigger({
            version_id: automDetail.versionId,
            trigger_type: null,
            trigger_config: {
                trigger_mode_id: null,
                application_credential_id: null,
                trigger_setup: {}
            }
        }, automDetail.id);


        if (response && response.status) {
            setTriggerSelectionData([]);
            setAutomDetail({
                ...automDetail,
                integration_type: "STANDARD",
                trigger_type: null
            });
            setReCheck(!reCheck);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.TRIGGER.CONFIGURATION-RESET-SUCCESS"),
                severity: response.status ? 'success' : 'error'
            }))
        }
    }

    const updateVariableByItemId = async (item_id, label) => {
        const i = variables.findIndex(x => x.related_item_id === item_id);
        if (i !== -1) {
            const newData = {
                updatingFields: [
                    {
                        field_name: "display_name",
                        field_value: label,
                    }
                ]
            }
            const result = await VariableService.updateVariable(newData, variables[i].id);
            if (result && result.status) {
                let copyVariables = JSON.parse(JSON.stringify(variables));
                copyVariables[i].display_name = label;
                setVariables(copyVariables);
            }
        }
    }

    return (

        !loader &&
        <div
            className={`${showRightArea ? "new-flow-with-right" : "new-flow-without-right"} new-flow-container ${showTriggerRightArea ? "trigger" : ""}`}>
            <div className="new-flow-left">
                <LeftArea
                    automType={automDetail.type}
                    handleDragStart={handleDragStart}
                    handleDragEnd={handleDragEnd}
                    variables={variables}
                    setVariables={setVariables}
                    setOpenVariable={setOpenVariable}
                    openVariable={openVariable}
                    automVersionId={automVersion}
                />
            </div>
            <div className="new-flow-middle">
                <MiddleArea
                    handleDragStart={handleDragStart}
                    automDetail={automDetail}
                    operationId={operationId}
                    setAutomDetail={setAutomDetail}
                    resetFlow={resetFlow}
                    saveFlow={saveFlow}
                    runFlow={runFlow}
                    debugFlow={debugFlow}
                    editFlow={editFlow}
                    tabFilter={tabFilter}
                    setTabFilter={setTabFilter}
                    detailTabs={detailTabs}
                    setDetailTabs={setDetailTabs}
                    isFocused={tabFilter > 0}
                    setTriggerModal={setTriggerModal}
                    setOpenSchedule={setOpenSchedule}
                    trigger={trigger}
                    isRunning={isRunning}
                    triggerType={triggerType}
                    handleStart={handleStart}
                    handleStop={handleStop}
                    publishFlow={publishFlow}
                    setOpenDrive={setOpenDrive}
                    debuggingStart={debuggingStart}
                    setDebuggingExpand={setDebuggingExpand}
                    openRunningModal={openRunningModal}
                    openDebugRunning={openDebugRunning}
                    setOpenDebugRunning={setOpenDebugRunning}
                    debuggingExpand={debuggingExpand}
                    handleRoi={handleRoi}
                    handleDiagramBuilder={handleDiagramBuilder}
                    findAndUpdateItem={dragItemSetField}
                    isDiagramBuilder={isDiagramBuilder}
                    diagramData={diagramData}
                    setIsDiagramBuilder={setIsDiagramBuilder}
                    setOpenRoi={setOpenRoi}
                    setDiagramData={setIsDiagramData}
                    handleDebugIconShow={handleDebugIconShow}
                    setShowRightArea={setShowRightArea}
                    setShowTriggerRightArea={setShowTriggerRightArea}
                    handleExport={handleExport}
                    handleImport={handleImport}
                    handleSlowMotion={handleSlowMotion}
                    setFlowStatus={setFlowStatus}
                    handleErrorOpenClick={handleErrorOpenClick}
                    handleErrorCloseClick={handleErrorCloseClick}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    action={actions[automDetail.activeItem[0]?.id]}
                    setReCheck={setReCheck}
                    reCheck={reCheck}
                    openResetTriggerConfiguration={openResetTriggerConfiguration}
                    testAppStarted={testAppStarted}
                    handleTestAppCancel={handleTestAppCancel}
                    automaticallyVariableCreation={automaticallyVariableCreation}
                    automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                    getVariables={getVariables}
                    updateVariableByItemId={updateVariableByItemId}
                />
                {debuggingStart && (
                    <Debugger
                        setDebugStatus={setDebugStatus}
                        openDebugRunning={openDebugRunning}
                        setDebuggingExpand={setDebuggingExpand}
                        showRightArea={showRightArea}
                        showTriggerRightArea={showTriggerRightArea}
                    />
                )}


                {/* {
                    showTriggerRightArea && (
                        <ConnectorField debugOpen={debuggingStart} debugExpand={debuggingExpand} />
                    )
                } */}

            </div>

            {
                showRightArea ?
                    <div className="new-flow-right">
                        <RightArea
                            setGroupLabel={setGroupLabel}
                            actions={actions}
                            // setSelected={setSelected}
                            selectedAction={actions[automDetail.activeItem[0]?.id]}
                            //setSelected={setSelectedAction}
                            mateId={automDetail?.mate_id}
                            variables={variables}
                            setVariables={setVariables}
                            setOpenVariable={setOpenVariable}
                            //variableRender={variableRender}
                            automId={paramsId}
                            automVersionId={automVersion}
                            recorder={recorder}
                            //setRender={setRenderExt}
                            debuggingStart={debuggingStart}
                            debuggingExpand={debuggingExpand}
                            drecorder={drecorder}
                            setShowRightArea={setShowRightArea}
                            showTriggerRightArea={showTriggerRightArea}
                            setShowTriggerRightArea={setShowTriggerRightArea}
                            fromFlow={true}
                            automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                        />
                    </div> :
                    <button className="new-flow-hide-right" onClick={handleShowRightArea}>
                        <ArrowLeft />
                    </button>
            }
            {openWaitingQueueModal && (
                <WaitingQueueModal
                    setOpen={setOpenWaitingQueueModal}
                    automDetail={automDetail}
                    numberQueue={numberQueue}
                />
            )}
            {openRunningModal && (
                <RunningModal
                    flowStatus={flowStatus}
                    setOpen={setOpenRunningModal}
                    setFlowStatus={setFlowStatus}
                    errorMessage={errorMessage}
                    operationId={operationId}
                    mateId={automDetail.mate_id}
                />
            )}
            {openPublish && (
                <Publish
                    flow={publishFlowData}
                    variables={variables}
                    automDetail={automDetail}
                    setOpenPublish={setOpenPublish}
                />
            )}
            {openEdit && (
                <EditAutomName
                    automDetail={automDetail}
                    setAutomDetail={setAutomDetail}
                    setOpenEdit={setOpenEdit}
                    setReCheck={setReCheck}
                    reCheck={reCheck}
                    automaticallyVariableCreation={automaticallyVariableCreation}
                />
            )}
            {openSchedule && (
                <Schedule
                    setOpen={setOpenSchedule}
                    automId={paramsId}
                />
            )}
            {triggerModal && (
                <TriggerModal
                    setOpen={setTriggerModal}
                    setOpenVariable={setOpenVariable}
                    variables={variables}
                    automDetail={automDetail}
                />
            )}
            {openDrive && (
                <MateDrive setOpen={setOpenDrive} flowId={paramsId} />
            )}
            {openRoi && <Roi setOpen={setOpenRoi} />}
            {openExport && (
                <ExportConfirm
                    setOpenExport={setOpenExport} message={t('CONTENT.FLOW.EXPORT-WARNING')} exportFunc={exportFunc}
                />
            )}
            {openImport && (
                <ImportModal
                    setOpenImport={setOpenImport} importFunc={importFunc}
                />
            )}
            {openSlowMotion && (
                <SlowMotionModal
                    setOpenSlowMotion={setOpenSlowMotion}
                    slowMotionFunc={slowMotionFunc}
                    timeout={debuggingDelay}
                />
            )}
            {openResetTrigger &&
                <DeleteConfirm setOpenDelete={setOpenResetTrigger}
                    message={t("CONTENT.FLOW.RESET-TRIGGER-CONFIRMATION")}
                    deleteFunc={resetTriggerConfiguration} />}
            {openTestAppLog &&
                <TestAppLog setOpenTestAppLog={setOpenTestAppLog} showTriggerRightArea={showTriggerRightArea}
                    showRightArea={showRightArea} openRunningModal={openRunningModal}
                    handleTestAppCancel={handleTestAppCancel} />
            }
            <Dialog
                open={openErrorDialog}
                onClose={handleErrorCloseClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Error Detail"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ color: "rgb(215, 94, 94)" }}>
                        {t("FLOW-MESSAGES.LIBRARY." + debugErrorMessage)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleErrorCloseClick} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default NewFlow;
